import React from 'react';
import Form from "react-bootstrap/Form";

export default function DateRange() {

const years = [ 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030 ]
const bars = [ 25, 27, 28, 29, 30, 31, 23, 31, 38, 36, 31, 38, 31, 24, 14, 19, 18, 14, 14, 16, 17,
    19, 25, 27, 28, 28, 14, 14, 14, 24, 25, 27, 28, 29, 30, 31, 23, 31, 38, 36, 31, 38, 31, 24, 14, 19,
    18, 14, 14, 16, 17, 19, 25, 27, 28, 28, 14, 14, 14, 24 ];



  return (
    <div className="d-flex align-items-center">
      <i className="mr-2 icon-play"></i>

      <div className="fw">
        <div className="d-flex justify-content-between align-items-end">
            { 
                bars.map((bar, i) => <span key={i} 
                style={{width: '7px', height: bar + 'px'}}
                className="bg-gray-800"></span>)
            }
        </div>

        <Form.Range />
        <div className="d-flex justify-content-between">
          {years.map((year) => (
            <small className="d-flex fw-300 text-sm-2" key={year}>
              {year}
            </small>
          ))}
        </div>
      </div>
    </div>
  );
}
